'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const root = require('bunsen/helpers/windowCheck');

const Tooltip = require('dibs-react-tooltip');
require('dibs-react-tooltip/dist/main.css');
const ItemTagIndicator = require('./ItemTagIndicator');
const GalleryPhotoItemTagInfo = require('./GalleryPhotoItemTagInfo');

const styles = require('./GalleryPhotoItemTags.scss');

const heightOfGlobalNav = 60;
const tooltipBoundMargin = 10;

/**
 * Returns the bounds of where the tooltip can be rendered
 *  (relative to the window @see dibs-react-tooltip)
 *
 * @returns {Object}
 */
function getBounds() {
    const wrapper = root.document.getElementsByClassName(styles.wrapper)[0];

    // Tooltip bounds to keep it from going outside the window
    const windowTopBound = heightOfGlobalNav;
    const windowLeftBound = 0;
    const windowRightBound = root.innerWidth;
    const windowBottomBound = root.innerHeight;

    // If for some reason wrapper isn't rendered, just return the window bounds
    if (!wrapper || !wrapper.getBoundingClientRect) {
        return {
            top: windowTopBound,
            left: windowLeftBound,
            right: windowRightBound,
            bottom: windowBottomBound,
        };
    }

    // Get image position relative to the window
    const imgPos = wrapper.getBoundingClientRect();

    // Tooltip bounds to keep it from going outside the image
    const imageTopBound = imgPos.top;
    const imageLeftBound = imgPos.left - tooltipBoundMargin;
    const imageRightBound = imgPos.right + tooltipBoundMargin;
    const imageBottomBound = imgPos.bottom;

    return {
        top: Math.max(imageTopBound, windowTopBound),
        left: Math.max(imageLeftBound, windowLeftBound),
        right: Math.min(imageRightBound, windowRightBound),
        bottom: Math.min(imageBottomBound, windowBottomBound),
    };
}

function tooltipProps({ tooltipVisible }) {
    return {
        containerClass: styles.itemTagTooltip,
        getBounds,
        isVisible: tooltipVisible,
        positionThreshold: {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
        },
    };
}

function onMouseEnter({ id, showItemTagTooltip }) {
    return () => showItemTagTooltip(id);
}

function onMouseLeave({ hideItemTagTooltip }) {
    return () => hideItemTagTooltip();
}

function GalleryPhotoItemTag(props) {
    const { point, isActiveTag } = props;
    const itemTagPosition = {
        top: `${point.y}%`,
        left: `${point.x}%`,
    };
    const className = classNames(styles.itemTagWrapper, {
        [styles.isActiveTag]: isActiveTag,
    });

    return (
        <div
            className={className}
            style={itemTagPosition}
            onMouseEnter={onMouseEnter(props)}
            onMouseLeave={onMouseLeave(props)}
        >
            {/* Tooltip */}
            <Tooltip {...tooltipProps(props)}>
                <GalleryPhotoItemTagInfo
                    name={props.name}
                    creator={props.creator}
                    category={props.category}
                    similarItemsUrl={props.similarItemsUrl}
                    trackLinkClick={props.trackLinkClick}
                />
                {/* Adding a space filling element so that the tool tip doesn't disappear when */}
                {/* the user mouses over the space between the tag indicator and tooltip */}
                <div className={styles.itemTagHoverBounds} />
            </Tooltip>

            {/* Item Tag Indicator */}
            <ItemTagIndicator />
        </div>
    );
}

GalleryPhotoItemTag.propTypes = {
    isActiveTag: PropTypes.bool.isRequired,
    tooltipVisible: PropTypes.bool.isRequired,

    id: PropTypes.number,
    name: PropTypes.string,
    creator: PropTypes.string,
    category: PropTypes.string,
    point: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired,
    }),
    similarItemsUrl: PropTypes.string,

    showItemTagTooltip: PropTypes.func.isRequired,
    hideItemTagTooltip: PropTypes.func.isRequired,
    trackLinkClick: PropTypes.func.isRequired,
};

module.exports = GalleryPhotoItemTag;



// WEBPACK FOOTER //
// ./assets/js/gallery/components/GalleryPhotoItemTag.jsx